import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { ArrowRightIcon, CalendarIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { bids } from '../../data/bids';
export function LatestBids() {
  const latestBids = bids.filter(b => b.status !== 'closed').slice(0, 4);
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4" data-id="element-142">
        <SectionHeading title="Current Bids & Tenders" subtitle="Explore procurement opportunities and submit your proposals" data-id="element-143" />

        <div className="grid md:grid-cols-2 gap-6 mt-12" data-id="element-144">
          {latestBids.map((bid, index) => <motion.div key={bid.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-145">
              <Card hover data-id="element-146">
                <div className="flex items-start justify-between mb-3" data-id="element-147">
                  <span className="text-sm font-mono text-gray-500" data-id="element-148">
                    {bid.reference}
                  </span>
                  <StatusPill status={bid.status} data-id="element-149">
                    {bid.status === 'closing-soon' ? 'CLOSING SOON' : 'OPEN'}
                  </StatusPill>
                </div>
                <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-150">
                  {bid.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-151">{bid.description}</p>
                <div className="flex items-center gap-4 text-sm text-gray-600 mb-3" data-id="element-152">
                  <div className="flex items-center gap-1" data-id="element-153">
                    <CalendarIcon size={16} data-id="element-154" />
                    <span data-id="element-155">
                      Published:{' '}
                      {new Date(bid.publicationDate).toLocaleDateString('en-GB')}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-sm font-medium text-au-red mb-4" data-id="element-156">
                  <ClockIcon size={16} data-id="element-157" />
                  <span data-id="element-158">
                    Deadline:{' '}
                    {new Date(bid.deadline).toLocaleDateString('en-GB')}
                  </span>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-159">
                  <span className="text-sm text-gray-600" data-id="element-160">{bid.category}</span>
                  {bid.estimatedValue && <span className="text-sm font-bold text-charcoal" data-id="element-161">
                      {bid.estimatedValue}
                    </span>}
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-162">
          <Link to="/bids" data-id="element-163">
            <Button variant="primary" className="flex items-center gap-2 mx-auto" data-id="element-164">
              View All Bids
              <ArrowRightIcon size={20} data-id="element-165" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}